import * as React from 'react'

import { Box, Button, Checkbox } from '@factorialco/deprecated-design-system'
import {
  AtsBulkDeleteCandidatesDocument,
  AtsBulkDeleteCandidatesMutation,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  candidateIds: string[]
  onClose: () => void
}

export const DeleteCandidateModal = ({ candidateIds, onClose }: Props) => {
  const [agreeCheckbox, setAgreeCheckbox] = React.useState(false)

  const [bulkDeleteCandidatesMutation, { loading }] = useMutation(AtsBulkDeleteCandidatesDocument, {
    extractorFn: (data: AtsBulkDeleteCandidatesMutation) =>
      data.atsMutations.bulkDeleteAtsCandidate,
  })

  const onSubmit = async () => {
    const result = handleResult(
      await bulkDeleteCandidatesMutation({
        variables: { ids: candidateIds },
        update(cache) {
          candidateIds.forEach((id) => {
            cache.evict({ id: cache.identify({ id, __typename: 'AtsCandidate' }) })
          })
        },
      }),
      () => undefined
    )

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.candidates.delete_modal.error_message'),
      })
    }

    onClose()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('ats.candidates.delete_modal.title')}
      description={i18n.t('ats.candidates.delete_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
          <Button type="secondary" disabled={loading} onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" disabled={loading || !agreeCheckbox} submit>
            {i18n.t('ats.candidates.delete_modal.submit')}
          </Button>
        </Box>
      }
    >
      <Checkbox
        checked={agreeCheckbox}
        label={i18n.t('ats.candidates.delete_modal.checkbox_label')}
        onChange={(event) => setAgreeCheckbox(event.target.checked)}
      />
    </Modal>
  )
}
